import { apiClient } from "../apiClient";
import { IChangePasswordRequest } from "../../model/request/auth/IChangePasswordRequest";
import { IDevResetPasswordRequest } from "../../model/request/auth/IDevResetPasswordRequest";
import { ILoginRequest } from "../../model/request/auth/ILoginRequest";
import { ILoginVnptRequest } from "../../model/request/auth/ILoginVnptRequest";
import { ILoginNamVietRequest } from "../../model/request/auth/ILoginNamVietRequest";
import { ILoginRespone, IUserInfo } from "../../model/respone/auth/ILoginRespone";

export const authApi = {
    Login: (req: ILoginRequest) => apiClient.post<ILoginRespone>("auth/login", req),
    /** SSO VNPT — đổi code (PKCE) lấy JWT. */
    LoginVnpt: (req: ILoginVnptRequest) => apiClient.post<ILoginRespone>("auth/login-vnpt", req),
    /** SSO Nam Việt / ESSOFT — gửi access_token (oidc-react) lấy JWT. */
    LoginNamViet: (req: ILoginNamVietRequest) => apiClient.post<ILoginRespone>("auth/login-namviet", req),
    /** Đổi one-time code (nhận ở /oauth-callback) lấy JWT sau khi đăng nhập Google/Microsoft. */
    OAuthExchange: (code: string) => apiClient.post<ILoginRespone>("auth/oauth/exchange", { code }),
    Me: () => apiClient.get<IUserInfo>("auth/me"),
    ChangePassword: (req: IChangePasswordRequest) =>
        apiClient.post<{ message: string; access_token?: string; expires_at?: string }>(
            "auth/change-password",
            req
        ),
    DevResetPassword: (req: IDevResetPasswordRequest) =>
        apiClient.post<{ message: string }>("auth/dev-reset-password", req),
};
